import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import * as styles from './NewAffiliate.scss';
var NewAffiliateFormStep2 = (_dec = connect(function (state) {
  return _defineProperty({
    whiteLabel: state.whiteLabel,
    theme: state.theme,
    productsByOrgId: state.products.productsByOrgId,
    orgDetails: state.newAffiliate.orgDetails,
    affiliateProductId: state.newAffiliate.affiliateConfig.affiliateProductId
  }, "theme", state.theme);
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewAffiliateFormStep2, _Component);

  var _super = _createSuper(NewAffiliateFormStep2);

  function NewAffiliateFormStep2() {
    var _this;

    _classCallCheck(this, NewAffiliateFormStep2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "renderChecklistItem", function (text, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.step3Item,
        key: "checklistItem_".concat(index)
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-android-checkmark-circle ".concat(styles.step3ItemIcon),
        style: {
          color: _this.props.theme.colors.secondaryColor
        }
      }), text);
    });

    _defineProperty(_assertThisInitialized(_this), "renderProduct", function (product) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333',
          padding: 16,
          borderRadius: 2,
          border: '1px solid gray'
        }
      }, product.title && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 17,
          borderBottom: '1px solid gray',
          paddingBottom: 4,
          marginBottom: 4
        }
      }, product.title), product.description && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15,
          marginBottom: 12,
          fontStyle: 'italic'
        }
      }, product.description), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15
        }
      }, "Monthly Price: ", _this.formatCurrency(parseInt(product.retailMonthlyPrice, 10) + parseInt(product.adsBudget, 10))), parseInt(product.adsBudget, 10) !== 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 13,
          marginBottom: 16,
          lineHeight: '16px'
        }
      }, "Includes ", _this.formatCurrency(product.adsBudget), "/mo ads budget."), parseInt(product.retailSetupFee, 10) !== 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15
        }
      }, "Setup Fee: ", _this.formatCurrency(product.retailSetupFee)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderClientDetails", function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15
        }
      }, "Business Name: ", _this.props.orgDetails.businessName), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15
        }
      }, "Email: ", _this.props.orgDetails.email), _this.props.orgDetails.firstName && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15
        }
      }, "First Name: ", _this.props.orgDetails.firstName), _this.props.orgDetails.lastName && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15
        }
      }, "Last Name: ", _this.props.orgDetails.lastName));
    });

    return _this;
  }

  _createClass(NewAffiliateFormStep2, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var contractInfo = this.props.contractInfo;
      var selectedProduct = this.props.productsByOrgId[this.props.theme.org].find(function (product) {
        return parseInt(product.id, 10) === parseInt(_this2.props.affiliateProductId, 10);
      });
      var partnerName = this.props.whiteLabel && this.props.whiteLabel.Organization ? this.props.whiteLabel.Organization.name : 'Partner';
      var newAffiliateName = this.props.orgDetails && this.props.orgDetails.businessName && this.props.orgDetails.businessName !== '' ? this.props.orgDetails.businessName : 'New Affiliate';
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.step3Header
      }, "Product Confirmation"), this.renderProduct(selectedProduct))), /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.step3Header
      }, "Client Details"), this.renderClientDetails(), /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333',
          marginTop: 16
        }
      }, "Payment will be entered by:", ' ', this.props.orgDetails.paymentDetailEntryType === 2 ? partnerName : newAffiliateName)), /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#333'
        }
      }, "Click Finish below to add ", newAffiliateName, ".")));
    }
  }]);

  return NewAffiliateFormStep2;
}(Component)) || _class);
export { NewAffiliateFormStep2 as default };